import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const Index = (props) => {
  // Render the title as a semantic heading tag (h1-h6) when `as` is provided,
  // otherwise fall back to a plain <div> so existing usages are unaffected.
  const HeadingTag = props.as || "div";
  return (
    <>
      <div
        className={`section-header-wrapper d-flex
        ${props.type} ${props.size}`}
        onClick={props.onClick}
      >
        <HeadingTag className="section-header-title">{props.text}</HeadingTag>
      </div>
    </>
  );
};

Index.propTypes = {
  text: PropTypes.string.isRequired,
};

Index.defaultProps = {
  text: "text not found",
  icon: "<RiCloseFill/>",
};

export default Index;
